export default "__VITE_ASSET__BSuRxrPT__"